import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

// utils
import { get } from "../../../utils/apiService";

// components
import UsersTable from "./UsersTable";
import UsersForm from "./UsersForm";

class Users extends Component {
  constructor() {
    super();

    this.state = {
      users: []
    };
  }
  componentDidMount() {
    let url = "/users";
    get(url).then(res => {
      let users = res.data;
      this.setState({ users });
    });
  }
  render() {
    return (
      <Grid>
        <Row>
          <Col md={12}>
            <UsersForm />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <UsersTable users={this.state.users} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/components/pages/Users/index.js